export default "./dist/stdassets/images/icons/zoom-out-fixed.png";